import React from 'react';
import PropTypes from 'prop-types';

import styles from './Charts.module.scss';

const Chart = React.memo(({ className, title, children }) => {
  return (
    <div className={className}>
      <p className={styles.chart_title}>{title}</p>
      {children && children}
    </div>
  );
});

Chart.defaultProps = {
  title: undefined,
  className: '',
};

Chart.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.element.isRequired,
};

export default Chart;
